const middleware = {}

middleware['authenticated'] = require('../../../middleware/authenticated.coffee')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['client-only-pages'] = require('../../../middleware/client-only-pages.js')
middleware['client-only-pages'] = middleware['client-only-pages'].default || middleware['client-only-pages']

middleware['unauthenticated'] = require('../../../middleware/unauthenticated.coffee')
middleware['unauthenticated'] = middleware['unauthenticated'].default || middleware['unauthenticated']

export default middleware
